import React, { useEffect, useState } from 'react'
import {Button, Form, Modal, Tab, Tabs } from 'react-bootstrap'
import RakennustietoRow from './RakennustietoRow';
import rakennusKoodit from '../assets/rakennusKoodit';
import MapModalWrapper from './MapModalWrapper';
import TilastoTable from './TilastoTable';
import MMLTabFetcher from './MMLTabFetcher';
import { patchIsMainBuilding, updateKiinteisto, updateRakennus } from '../api/api.js'
import { useSearchParams } from 'react-router-dom';
import EditableRow from './EditableRow.jsx';
import KiinteistoDetails from './KiinteistoDetails.jsx'
import YmparistoTab from "./YmparistoTab"

import EnergiaTaulut from './Energia/EnergiaTaulut.js';
import YhteyshenkilotTab from './YhteyshenkilotTab.js';
import KohoLinkki from './KohoLinkki.jsx';
import { PERMISSIONS } from '../permissions/permissions.js';
import Can from '../permissions/Can.jsx';

export default function PerustiedotTab({card, setCard}) {
  const [showModal, setShowModal] = useState(false);
  const [selectedRakennus, setSelectedRakennus] = useState(null);

  const [searchParams, setSearchParams] = useSearchParams();
  const initialSubTab = searchParams.get('subtab') || 'Kiinteistö';
  const [perustiedotActiveKey, setPerustiedotActiveKey] = useState(initialSubTab);


  const handleOpenModal = (rakennus) => {
    setSelectedRakennus(rakennus);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedRakennus(null);
  };



const handleToggleMainBuilding = async (rakennus) => {
  try {
    // flip the value
    const newValue = !rakennus.isMainBuilding;

    // call backend
    await patchIsMainBuilding(rakennus.id_rakennus, { value: newValue });

    // update UI
    const updated = card.rakennukset_fulls.map(r =>
      r.id_rakennus === rakennus.id_rakennus
        ? { ...r, isMainBuilding: newValue }
        : r
    );

    setCard({ ...card, rakennukset_fulls: updated });
  } catch (err) {
    console.error("Failed to toggle main building", err);
  }
};

useEffect(() => {
  const subtabFromUrl = searchParams.get('subtab') || 'Kiinteistö';
  setPerustiedotActiveKey(subtabFromUrl);
}, [searchParams]);

const handleSetMainBuilding = async (rakennus) => {
  try {
    await patchIsMainBuilding(rakennus.id_rakennus, { value: true });

    // update UI (optimistic update)
    const updated = card.rakennukset_fulls.map(r =>
      r.id_rakennus === rakennus.id_rakennus
        ? { ...r, isMainBuilding: true }
        : { ...r, isMainBuilding: false } 
    );

    setCard({ ...card, rakennukset_fulls: updated }); 
  } catch (err) {
    console.error("set main failed", err);
  }
};

const displayValue = (value) => {
  if (value === null || value === undefined || value === '' || value === 'null') return '—';
  return value;
};



    return (

        <div
            className="container-fluid px-3 px-md-4 mb-4"
            style={{ fontSize: '0.9rem', lineHeight: '1.4' }}
          >
        <div>
            <div className="d-flex justify-content-center mt-1 mb-1">
              <Tabs
                activeKey={perustiedotActiveKey}
                onSelect={(k) => {
                  setPerustiedotActiveKey(k);
                  // Update the URL without losing the main tab
                  setSearchParams({ 
                    tab: 'perustiedot', 
                    subtab: k 
                  });
                }}
                id="taloyhtiokortti-subtabs"
                className="mb-0 custom-tabs2 justify-content-center"
                variant="pills"
              >
                <Tab eventKey="Kiinteistö" title={<span className="text-white">Kiinteistö</span>} />
                {/* <Tab eventKey="Rakennukset" title={<span className="text-white">Rakennukset</span>} /> */}
                <Tab eventKey="Yhteyshenkilöt" title={<span className="text-white">Yhteyshenkilöt</span>} />
                <Tab eventKey="Ymparisto" title={<span className="text-white">Ympäristö</span>} />

                {/* <Tab eventKey="Energia" title={<span className="text-white">Energia</span>} /> */}
                <Tab eventKey="Hae tietoja" title={<span className="text-white">Hae tietoja</span>} />
              </Tabs>

            </div>

            <div className="mt-1">
                {perustiedotActiveKey === 'Kiinteistö' && (
                  <>
                    {/* showMap renders the map inside KiinteistoDetails'
                        own right column, above the SharePoint block and
                        in the same row as the Perustiedot panel — a
                        standalone row replicated outside the component
                        couldn't match its grid/padding exactly and left
                        an awkward empty gap next to the map. */}
                    <KiinteistoDetails card={card} setCard={setCard} showMap />
                    <div style={{ maxWidth: '80%' }}>
                      <KohoLinkki card={card} />
                    </div>
                  </>
                )}

                {/* Rakennukset ala-tabi perustiedoissa */}
                    {perustiedotActiveKey === 'Ymparisto' && card && (
                      <YmparistoTab kiinteisto={card} />
                    )}
                {perustiedotActiveKey === 'Rakennukset' && card?.rakennukset_fulls?.length > 0 && (
                <div className="mt-3">

                  {/* Mobile: card list */}
                  <div className="d-flex d-md-none flex-column gap-2">
                    {card.rakennukset_fulls.map((rakennus, idx) => (
                      <div key={rakennus.rakennustunnus || idx} className="border rounded p-2 bg-white d-flex justify-content-between align-items-center gap-2">
                        <div style={{ fontSize: '0.8rem' }}>
                          <div className="fw-semibold">{rakennus?.rakennustunnus || '—'}</div>
                          <div className="text-muted">{rakennus?.rakennusluokitus || '—'}</div>
                        </div>
                        <div className="d-flex align-items-center gap-2 flex-shrink-0">
                          <Form.Check
                            type="switch"
                            id={`main-switch-mob-${rakennus.id_rakennus}`}
                            checked={rakennus.isMainBuilding}
                            onChange={() => handleToggleMainBuilding(rakennus)}
                            className="m-0"
                            style={{ fontSize: '0.75rem' }}
                          />
                          <Button size="sm" variant="success" style={{ fontSize: '0.75rem', padding: '2px 8px' }} onClick={() => handleOpenModal(rakennus)}>
                            Tiedot
                          </Button>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Desktop: table */}
                  <div className="d-none d-md-block table-responsive">
                    <table className="table table-sm" style={{ borderCollapse: 'separate', borderSpacing: '0 0.5rem' }}>
                      <thead>
                        <tr>
                          <th>Rakennustunnus</th>
                          <th>Rakennusluokitus</th>
                          <th>Ensisijainen</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {card.rakennukset_fulls.map((rakennus, idx) => (
                          <tr key={rakennus.rakennustunnus || idx} style={{ borderBottom: '1px solid #e9ecef' }}>
                            <td className="text-start fw-semibold pe-3" style={{ verticalAlign: 'middle' }}>{rakennus?.rakennustunnus || '—'}</td>
                            <td className="text-start" style={{ verticalAlign: 'middle' }}>{rakennus?.rakennusluokitus || '—'}</td>
                            <td className="text-start align-middle">
                              <Form.Check type="switch" id={`main-switch-${rakennus.id_rakennus}`} checked={rakennus.isMainBuilding} onChange={() => handleToggleMainBuilding(rakennus)} className={rakennus.isMainBuilding ? "text-success m-0" : "m-0"} />
                            </td>
                            <td className="text-start" style={{ verticalAlign: 'middle' }}>
                              <Button size="sm" variant="success" onClick={() => handleOpenModal(rakennus)}>Tiedot</Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                {/* Tilastoja */}

                <div className="border-top border-success my-3" style={{ height: '3px' }} />
               
                <TilastoTable
                    kunta={card?.rakennukset_fulls[0]?.toimipaikka}
                    chartLabel={'pientalojen kauppahinnat'}
                />

                {/* Modaali joka avataan ku avataan jonkun rakennuksen tiedot */}
                
                <Modal
                    show={showModal}
                    onHide={handleCloseModal}
                    centered
                    fullscreen="md-down"
                    size="xl"
                    contentClassName="border-success rounded-3"
                >
                <Modal.Header closeButton className="bg-success bg-opacity-10 border-success">
                    <Modal.Title className="text-success">Rakennuksen tiedot</Modal.Title>
                    {selectedRakennus?.sijainti?.coordinates?.[1] && (
                        <MapModalWrapper coords={[selectedRakennus.sijainti.coordinates[1], selectedRakennus.sijainti.coordinates[0]]} />
                        )}
                </Modal.Header>
                

                                

                <Modal.Body className="px-4 py-3">
                    {selectedRakennus ? (
                    <dl className="row gy-3">
                        {/* Identification */}
                        <RakennustietoRow
                        otsikko="Rakennustunnus"
                        field="rakennustunnus"
                        rakennus={selectedRakennus}
                        editable={true}
                        showSource={true}
                        />

                        {/* Address */}
                        <RakennustietoRow otsikko="Osoite" field="osoite" rakennus={selectedRakennus} editable showSource />
                        <RakennustietoRow otsikko="Toimipaikka" field="toimipaikka" rakennus={selectedRakennus} editable showSource />
                        <RakennustietoRow otsikko="Postinumero" field="postinumero" rakennus={selectedRakennus} editable showSource />

                        <div className="border-top border-success my-3" />

                        {/* Basic Info */}
                        <RakennustietoRow
                        otsikko="Rakennusluokitus"
                        field="rakennusluokitus"
                        rakennus={selectedRakennus}
                        editable
                        showSource
                        options={rakennusKoodit.rakennusluokitus}
                        />
                        <RakennustietoRow otsikko="Rakennusvuosi" field="rakennusvuosi" rakennus={selectedRakennus} editable showSource />
                        <EditableRow otsikko={"Peruskorjauvuosi"} item={selectedRakennus} field={"peruskorjausvuosi"} idField="id_rakennus" updateFn={updateRakennus} editable showSource/>
                        <EditableRow otsikko={"Laajennusvuosi"} item={selectedRakennus} field={"laajennusvuosi"} idField="id_rakennus" updateFn={updateRakennus} editable showSource/>


                        <div className="border-top border-success my-3" />

                        {/* Size & Volume */}
                        <RakennustietoRow otsikko="Kokonaisala (m²)" field="kokonaisala" rakennus={selectedRakennus} editable showSource />
                        <RakennustietoRow otsikko="Kerrosala (m²)" field="kerrosala" rakennus={selectedRakennus} editable showSource />
                        <RakennustietoRow otsikko="Huoneistoala (m²)" field="huoneistoala" rakennus={selectedRakennus} editable showSource />
                        <RakennustietoRow otsikko="Tilavuus (m³)" field="tilavuus" rakennus={selectedRakennus} editable showSource />
                        <RakennustietoRow otsikko="Kerroksia" field="kerroksia" rakennus={selectedRakennus} editable showSource />
                        <RakennustietoRow otsikko="Huoneistojen lukumäärä" field="huoneistoja" rakennus={selectedRakennus} editable showSource />

                        <div className="border-top border-success my-3" />

                        {/* Structure */}
                        <RakennustietoRow
                        otsikko="Runkotapa"
                        field="runkotapa"
                        rakennus={selectedRakennus}
                        editable
                        showSource
                        options={rakennusKoodit.rakentamistapa}
                        />
                        <RakennustietoRow
                        otsikko="Käyttötilanne"
                        field="kayttotilanne"
                        rakennus={selectedRakennus}
                        editable
                        showSource
                        options={rakennusKoodit.kayttotilanne}
                        />

                        {/* Materials & Heating */}
                        <RakennustietoRow
                        otsikko="Julkisivumateriaali"
                        field="julkisivumateriaali"
                        rakennus={selectedRakennus}
                        editable
                        showSource
                        options={rakennusKoodit.julkisivumateriaali}
                        />
                        <RakennustietoRow
                        otsikko="Lämmitystapa"
                        field="lammitystapa"
                        rakennus={selectedRakennus}
                        editable
                        showSource
                        options={rakennusKoodit.lammitystapa}
                        />
                        <RakennustietoRow
                        otsikko="Lämmitysenergialähde"
                        field="lammitysenergialahde"
                        rakennus={selectedRakennus}
                        editable
                        showSource
                        options={rakennusKoodit.lammitysenergialahde}
                        />
                        <RakennustietoRow
                        otsikko="Rakennusaine"
                        field="rakennusaine"
                        rakennus={selectedRakennus}
                        editable
                        showSource
                        options={rakennusKoodit.rakennusaine}
                        />
                    </dl>
                    ) : (
                    <p>Ei tietoja</p>
                    )}
                </Modal.Body>

                <Modal.Footer className="bg-light">
                    <Button variant="secondary" onClick={handleCloseModal}>
                    Sulje
                    </Button>
                </Modal.Footer>
                </Modal>
                </div>
                )}
            </div>

            {perustiedotActiveKey === 'Hae tietoja' && card && (
                <div>
                    <Can permission={PERMISSIONS.TALOYHTIOKORTTI.USE_HAE_TIETOJA} mode='disable'>
                      <MMLTabFetcher kohdetunnus={card?.kiinteistotunnus}></MMLTabFetcher>
                    </Can>
                </div>

            )}

            {perustiedotActiveKey === 'Energia' && card && (
                // <div>
                //     <EnergiaTaulut type={'lampo'}></EnergiaTaulut>
                // </div>
                <></>

            )}

            {perustiedotActiveKey === 'Yhteyshenkilöt' && card && (
                <YhteyshenkilotTab id_kiinteisto={card?.id_kiinteisto}></YhteyshenkilotTab>
            )}

        
            </div>
        </div>
    )
}
